<template lang="pug">
  div(
    :class="['qr-code-promo-wrapper', { opened: isQrVisible }]"
    v-if="showQrCodePromo"
  )
    div(class="qr-code-promo")
      div(class="qr-code-promo-title")
        | {{ isQrVisible ? $t('Scan QR Code') : $t('Install app') }}
        e-svg-icon(
          class="qr-code-promo-icon"
          name="close"
          @click="isQrVisible ? toggleQr() : closeQr()"
        )
      div(class="qr-code-promo-text")
        | {{ isQrVisible ? $t('Scan QR Code description') : $t('Install app description') }}
      template(v-if="isQrVisible")
        QrcodeVue(
          :value="qrCodeData"
          :size="106"
          level="H"
          class="qr-code-promo-code"
        )
      template(v-else)
        v-btn(
          class="outlined-button qr-code-promo-button"
          @click="toggleQr"
        ) {{ $t('Install') }}
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'MBlockQrCodePromo',
  components: { QrcodeVue },
  data: () => ({
    isQrVisible: false,
    showQrCodePromo: true
  }),
  computed: {
    qrCodeData() {
      return 'https://my.dubidoc.com.ua/open-main'
    }
  },
  created() {
    this.showQrCodePromo = this._.get(this.$localStorageClientData, 'showQrCodePromo', true)
  },
  methods: {
    toggleQr() {
      this.isQrVisible = !this.isQrVisible
    },
    closeQr() {
      this.isQrVisible = false
      this.showQrCodePromo = false
      this.$setLocalStorageClientData({ showQrCodePromo: false })
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-code-promo {
  padding: 12px;
  width: 100%;
  height: 100%;
  position: relative;

  &-wrapper {
    height: 196px;
    width: 184px;
    position: fixed;
    left: 12px;
    bottom: 6px;
    border-radius: 12px;
    background: $primary-light url('~~/assets/images/phone.png') no-repeat;
    background-position: 115% 50%;

    &.opened {
      background: $primary-light;
    }
  }

  &-title {
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    color: $text-dark;

    position: relative;
  }

  &-text {
    font-size: 10px;
    line-height: 16px;
    font-weight: 300;
    color: $text-darkgray;

    padding-top: 4px;
    max-width: 140px;
  }

  &-icon {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    width: 16px;
    height: 16px;
  }

  &-button {
    position: absolute;
    bottom: 12px;
    left: 12px;
  }

  &-code {
    padding-top: 12px;
  }
}
</style>
